// extracted by mini-css-extract-plugin
export var roundInProgressContainer = "RoundInProgress-module--roundInProgressContainer--2kP_P";
export var player = "RoundInProgress-module--player--34IGv";
export var mode = "RoundInProgress-module--mode--_A-DF";
export var modeDescription = "RoundInProgress-module--modeDescription--1PCwK";
export var syllable = "RoundInProgress-module--syllable--Wyqqe";
export var goToNextPlayerButton = "RoundInProgress-module--goToNextPlayerButton--ynwZ6";
export var goToPreviousPlayerButton = "RoundInProgress-module--goToPreviousPlayerButton--2m101";